export const GET_VENDORS = {
  START: "VENDORS/GET_VENDORS_START",
  SUCCESS: "VENDORS/GET_VENDORS_SUCCESS",
  ERROR: "VENDORS/GET_VENDORS_ERROR",
};
